import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_FULL_SUNRISE = defineFcm('petition_page_full_sunrise')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			// Include any module that will be experimented on in the full sunrise migration
			keys: [
				'petitionDescription',
				'supporters',
				'petitionHeading',
				'sharePetition',
				'petitionUpdates',
				'promotedPetitions',
				'recentSigners',
				'actionPanel',
				'contentSummary',
				'petitionStarter',
				'mediaHits',
			] as const,
			optionalValues: true,
			shape: {
				type: 'object',
				optional: true,
				shape: {
					enabled: { type: 'boolean' },
					experimentName: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({
		petitionDescription: { enabled: false, experimentName: '' },
		supporters: { enabled: false, experimentName: '' },
		recentSigners: { enabled: false, experimentName: '' },
		promotedPetitions: { enabled: false, experimentName: '' },
		actionPanel: { enabled: false, experimentName: '' },
		contentSummary: { enabled: false, experimentName: '' },
		petitionStarter: { enabled: false, experimentName: '' },
		mediaHits: { enabled: false, experimentName: '' },
	})
	.toConfig();
